import Moment from 'moment';

const defaultState = {
  data: {
    script_responses: {},
    knock_statuses: {},
  },
  loading: false,
  error: false,
};

const responseAggregates = function (state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_CAMPAIGN_RESPONSE_AGG_CACHE':
      return { ...defaultState };

    case 'SET_RESPONSE_AGG_DATA':
      return { ...state, data: action.data };

    case 'SET_RESPONSE_AGG_LOADING':
      return { ...state, loading: action.data };

    case 'SET_RESPONSE_AGG_ERROR':
      return { ...state, error: action.data };

    default:
      return state;
  }
};

export default responseAggregates;
